import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../store/user/selectors";
import { selectUsersState } from "../store/users/selectors";
import { getUsersByTenant } from "../store/users/thunks";

export const useTenantUsers = ({ fetchUsers = true } = {}) => {
  const dispatch = useDispatch();
  const selectedTenantId = useSelector(selectSelectedTenantId);
  const { usersByTenant, loading } = useSelector(selectUsersState);

  useEffect(() => {
    if (selectedTenantId && !usersByTenant[selectedTenantId] && fetchUsers) {
      dispatch(getUsersByTenant({ tenant_id: selectedTenantId }));
    }
  }, [selectedTenantId, usersByTenant, dispatch, fetchUsers]);

  const { users, usersOptions } = useMemo(() => {
    const tempUsers = usersByTenant[selectedTenantId] || [];
    return {
      users: tempUsers,
      usersOptions: tempUsers.map((u) => ({
        label: `${u.first_name} ${u.last_name}`,
        value: u.id,
      })),
    };
  }, [usersByTenant, selectedTenantId]);

  return { users, loading, selectedTenantId, usersOptions };
};
